module.exports = __webpack_public_path__ + "img/chat-user5.67c21f8b.png";